import { useQuery } from '@tanstack/react-query';
import { users } from '@/utils/api';

export function useUsers(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['users', params],
    queryFn: () => users.getAll(params).then((r) => r.data),
  });
}

export function useUser(id: number | string | undefined) {
  return useQuery({
    queryKey: ['users', id],
    queryFn: () => users.getById(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useYearlyStats(year: number) {
  return useQuery({
    queryKey: ['users', 'yearly-stats', year],
    queryFn: () => users.getYearlyStats(year).then((r) => r.data),
  });
}

export function useYearOverview(id: number | string | undefined, year: number) {
  return useQuery({
    queryKey: ['users', id, 'year-overview', year],
    queryFn: () => users.getYearOverview(id, year).then((r) => r.data),
    enabled: !!id,
  });
}

export function useStammblatt(id: number | string | undefined) {
  return useQuery({
    queryKey: ['users', id, 'stammblatt'],
    queryFn: () => users.getStammblatt(id).then((r) => r.data),
    enabled: !!id,
  });
}
